import useApi from "./useApi";
import useSessionStorage from "./useSessionStorage";

const useJob = () => {
    
    const {getJson} = useApi();
    const {jobSetJob, jobRemoveJob, jobRemoveCode } = useSessionStorage();
    
    /**
     * Fetches a job by its UUID and updates session storage
     * @param query
     */
    const fetchJobWithUuid = async (query) => {
        const _query = query ? `/${query}` : "";
        jobRemoveCode();
        jobRemoveJob();
        try {
            const res = await getJson(`/online/jobsearch/link${_query}`);
            jobSetJob(res.job[0]);
            return res.job[0];
        } catch (error) {
            console.error("Error fetching job with UUID:", error);
            throw error;
        }
    };
    
    return {
        fetchJobWithUuid
    }
}

export default useJob;
